import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'No local',
      [RoomServiceLocationType.TableService]: 'No local',
      both: 'No local',
    },
    [ORDER_METHODS.PICKUP]: 'Takeaway',
    [ORDER_METHODS.DELIVERY]: 'Entrega',
  },
};
